<script>
  export let promise;
  export let pid;

  let catinfo;
  promise.then(() => {
    catinfo = categoryInfo;
  });
  const domain = `${location.protocol}//${document.domain}`;

  const extractSubcatNumber = () => {
    if (location.href.indexOf("subcat") !== -1) {
      const subcatNum = Number(location.href.split("subcat=")[1]);
      const productSeries = categoryInfo["subCategory"][subcatNum];
      return productSeries;
    } else {
      return categoryInfo["subCategory"][0];
    }
  };

  //WordPress REST APIからカスタム投稿情報を取得
  const fetchPost = async () => {
    const res = await fetch(`${domain}/wp-json/wp/v2/shopbrand/${pid}`);
    const json = await res.json();
    if (res.ok) {
      return json;
    } else {
      throw new Error(json);
    }
  };

  //ダミー画像のURL
  const dummyUrl = `/images/dummy_logo.png`;
</script>

{#await promise then response}
  <div class="logo">
    <!-- slugまたはカテゴリーコードをもとに登録した画像を表示 -->
    {#await fetchPost() then res}
      {#if res.info.brandimage}
        <img src={res.info.brandimage} alt={catinfo["path01"]} />
        {:else}
        <img src={dummyUrl} alt={catinfo["path01"]} />
      {/if}
    {/await}
  </div>
  <div class="category">
    <h1>{catinfo["path01"]}</h1>
    <p>{extractSubcatNumber()}</p>
  </div>
{/await}

<style>
  .logo {
    width: 290px;
  }
  .category {
    width: 100%;
    align-self: center;
  }
  @media screen and (max-width: 1060px) {
    .logo {
      width: auto;
    }
  }
</style>
